import { apiService } from '../../shared/services/apiService';
import { TaxRateInfo } from '../interfaces/tax';
export const scanIqTaxService = {
  async getScanIqTaxRate(entityId: number) {
    const resp = await apiService.get<TaxRateInfo>(
      `/api/entity/${entityId}/scan-iq/tax-rate`,
    );

    return resp.data;
  },

  async createScanIqTaxRate(entityId: number, taxRatePercent: number) {
    const resp = await apiService.post<TaxRateInfo>(
      `/api/entity/${entityId}/scan-iq/tax-rate`,
      { taxRatePercent },
    );

    return resp.data;
  },

  async updateScanIqTaxRate(entityId: number, taxRateId: number, taxRatePercent: number) {
    const resp = await apiService.put<TaxRateInfo>(
      `/api/entity/${entityId}/scan-iq/tax-rate/${taxRateId}`,
      { taxRatePercent },
    );

    return resp.data;
  },
};
